import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { HowItWorks } from './components/HowItWorks';
import { BookingForm } from './components/BookingForm';
import { PricingTable } from './components/PricingTable';
import { ServicesSection } from './components/ServicesSection';
import { Guarantee } from './components/Guarantee';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { CoverageMap } from './components/CoverageMap';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { CallButton } from './components/CallButton';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-mf-gray font-sans text-mf-black selection:bg-mf-red selection:text-white relative" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <TrustBar data-id="element-5" />
          <HowItWorks data-id="element-6" />
          <BookingForm data-id="element-7" />
          <PricingTable data-id="element-8" />
          <ServicesSection data-id="element-9" />
          <Guarantee data-id="element-10" />
          <Gallery data-id="element-11" />
          <Testimonials data-id="element-12" />
          <CoverageMap data-id="element-13" />
          <FAQ data-id="element-14" />
          <FinalCTA data-id="element-15" />
        </main>
        <Footer data-id="element-16" />
        <CallButton data-id="element-17" />
      </div>
    </LanguageProvider>;
}